"use strict";
/** state: Final **/
/** family: Checkbox **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Button_1 = require("../Button");
var CLASS_NAME = 'i-checkbox';
var CheckboxMode;
(function (CheckboxMode) {
    CheckboxMode["Button"] = "button";
    CheckboxMode["Checkbox"] = "checkbox";
})(CheckboxMode = exports.CheckboxMode || (exports.CheckboxMode = {}));
/**
 * Checkboxes are used to allow users to opt in or out of certain choices.
 *
 * When using multiple checkboxes together, the choices should not be mutually-exclusive.
 * If you need mutually exclusive choices, consider using a {{Radio}}.
 */
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.componentDidMount = function () {
        if (this.props.checked === 'mixed') {
            this.input.indeterminate = true;
        }
    };
    Checkbox.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.checked !== this.props.checked) {
            this.input.indeterminate = nextProps.checked === 'mixed';
        }
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, labelHidden = _a.labelHidden, isInline = _a.isInline, mode = _a.mode, name = _a.name, value = _a.value, checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange, className = _a.className, restProps = __rest(_a, ["label", "labelHidden", "isInline", "mode", "name", "value", "checked", "disabled", "onChange", "className"]);
        var wrapperClasses = classNames(CLASS_NAME, className, 'custom-control', 'custom-checkbox', {
            'custom-control-inline': isInline,
        });
        var inputClasses = classNames(CLASS_NAME + "__input", 'custom-control-input', 'sr-only');
        var labelClasses = classNames(CLASS_NAME + "__label", 'custom-control-label', {
            disabled: disabled,
        });
        var buttonModeClasses = classNames('btn', "btn-" + Button_1.ButtonMode.Secondary, 'i-btn', CLASS_NAME + "__label--button", labelClasses);
        // determines whether we should apply button styling, or label styling
        var spanClasses = mode === CheckboxMode.Button ? buttonModeClasses : labelClasses;
        var handleChange = function (e) {
            var updatedProps = __assign({}, _this.props, { checked: e.target.checked });
            onChange && onChange(e, updatedProps);
        };
        return (React.createElement("label", __assign({ "aria-disabled": disabled, className: wrapperClasses }, restProps),
            React.createElement("input", { type: "checkbox", className: inputClasses, name: name, value: value, checked: checked === true, disabled: disabled, onChange: handleChange, ref: function (input) { return (_this.input = input); } }),
            React.createElement("span", { className: spanClasses }, !labelHidden && label)));
    };
    Checkbox.Mode = CheckboxMode;
    return Checkbox;
}(React.Component));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map